import { Component, ContentChildren, EventEmitter, Input, Output, ViewChildren, } from '@angular/core';
import { TemplateUuids } from '@mhe/ngx-shared/utils';
import { TabComponent } from './tab.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = ["tabElements"];
function TabsComponent_li_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r3 = i0.ɵɵnextContext().index;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i_r3 + 1);
} }
function TabsComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 5)(1, "a", 6, 7);
    i0.ɵɵlistener("click", function TabsComponent_li_2_Template_a_click_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r8); const i_r3 = restoredCtx.index; const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.tabClicked(i_r3, $event)); });
    i0.ɵɵtemplate(3, TabsComponent_li_2_span_3_Template, 2, 1, "span", 8);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", ctx_r0.showSteps && i_r3 === ctx_r0.tabIndex)("disabled", ctx_r0.showSteps && tab_r2.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("active", i_r3 === ctx_r0.tabIndex)("disabled", tab_r2.disabled);
    i0.ɵɵproperty("id", ctx_r0.getElementId("tab", i_r3));
    i0.ɵɵattribute("href", tab_r2.disabled ? null : "#", i0.ɵɵsanitizeUrl)("tabIndex", i_r3 === ctx_r0.tabIndex ? 0 : -1)("index", i_r3)("aria-selected", i_r3 === ctx_r0.tabIndex)("aria-controls", ctx_r0.getElementId("content", ctx_r0.tabIndex))("aria-disabled", tab_r2.disabled || null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showSteps);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("step-label", ctx_r0.showSteps);
    i0.ɵɵattribute("aria-label", tab_r2.ariaLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(tab_r2.name);
} }
function TabsComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
export class TabsComponent {
    constructor() {
        this.tabIndex = 0;
        this.showSteps = false;
        this.ariaLabel = '';
        this.ariaLabelledBy = '';
        this.tabClick = new EventEmitter();
        this.templateUuids = new TemplateUuids();
        this.customTabs = [];
        this.keys = {
            Left: 'ArrowLeft',
            Up: 'ArrowUp',
            Right: 'ArrowRight',
            Down: 'ArrowDown',
            Space: ' ',
        };
    }
    ngAfterViewInit() {
        this.customTabs = this.tabElements.map((tab) => tab.nativeElement);
        this.addListeners();
    }
    ngOnDestroy() {
        this.removeListeners();
    }
    removeListeners() {
        for (const tab of this.customTabs) {
            tab.removeEventListener('keydown', this.keydownEventListener);
        }
    }
    addListeners() {
        for (const tab of this.customTabs) {
            tab.addEventListener('keydown', this.keydownEventListener.bind(this));
        }
    }
    getElementId(name, id) {
        return this.templateUuids.get(name + String(id));
    }
    getAllTabIds() {
        return this.tabs.map((_, index) => this.getElementId('tab', index)).join(' ');
    }
    keydownEventListener(event) {
        const key = event.key;
        const target = event.target;
        const currentIndex = Number(target.getAttribute('index'));
        let targetIndex = -1;
        if (key === this.keys.Space) {
            this.tabClicked(currentIndex, event);
            event.preventDefault();
        }
        let dir = 'increment';
        if (key === this.keys.Left || key === this.keys.Up) {
            targetIndex = this.decrementTabIndex(currentIndex);
            dir = 'decrement';
        }
        else if (key === this.keys.Right || key === this.keys.Down) {
            targetIndex = this.incrementTabIndex(currentIndex);
            dir = 'increment';
        }
        if (targetIndex >= 0 && currentIndex !== targetIndex) {
            this.focusTab(targetIndex, dir);
            event.preventDefault();
        }
    }
    decrementTabIndex(index) {
        index = --index < 0 ? this.customTabs.length - 1 : index;
        return index;
    }
    incrementTabIndex(index) {
        index = ++index >= this.customTabs.length ? 0 : index;
        return index;
    }
    focusTab(index, focusDir = 'increment') {
        const tab = this.tabs.get(index);
        if (tab && !tab.disabled) {
            const selectedTab = this.customTabs[index];
            selectedTab.focus();
        }
        else {
            const someEnabled = this.tabs.some((t) => !t.disabled);
            const isIncrement = focusDir === 'increment';
            const skipToTab = isIncrement ? this.incrementTabIndex.bind(this) : this.decrementTabIndex.bind(this);
            const i = skipToTab(index);
            someEnabled && this.focusTab(i, focusDir);
        }
    }
    getActiveTabTemplate() {
        const activeTab = this.tabs.find(this.findActive.bind(this));
        return activeTab && activeTab.contentTemplate;
    }
    findActive(tab, index) {
        return this.isActive(index);
    }
    tabClicked(index, event) {
        const tab = this.tabs.toArray()[index];
        if (!tab.disabled) {
            this.tabClick.emit(index);
        }
        event.preventDefault();
    }
    isActive(index) {
        return index === this.tabIndex;
    }
}
TabsComponent.ɵfac = function TabsComponent_Factory(t) { return new (t || TabsComponent)(); };
TabsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TabsComponent, selectors: [["mhe-tabs"]], contentQueries: function TabsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, TabComponent, 4);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabs = _t);
    } }, viewQuery: function TabsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabElements = _t);
    } }, inputs: { tabIndex: "tabIndex", showSteps: "showSteps", ariaLabel: "ariaLabel", ariaLabelledBy: "ariaLabelledBy" }, outputs: { tabClick: "tabClick" }, decls: 5, vars: 11, consts: [[1, "tablist-label"], ["role", "tablist", 1, "nav"], ["role", "presentation", "class", "nav-item", 3, "active", "disabled", 4, "ngFor", "ngForOf"], ["role", "tabpanel", 3, "id"], [4, "ngTemplateOutlet"], ["role", "presentation", 1, "nav-item"], ["role", "tab", 1, "nav-link", 3, "id", "click"], ["tabElements", ""], ["class", "step-number", 4, "ngIf"], [1, "step-number"]], template: function TabsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "ul", 1);
        i0.ɵɵtemplate(2, TabsComponent_li_2_Template, 6, 20, "li", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, TabsComponent_ng_container_4_Template, 1, 0, "ng-container", 4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("nav-tabs", !ctx.showSteps)("nav-steps", ctx.showSteps);
        i0.ɵɵattribute("aria-label", ctx.ariaLabel ? ctx.ariaLabel : null)("aria-labelledby", ctx.ariaLabelledBy ? ctx.ariaLabelledBy : null)("aria-owns", ctx.getAllTabIds());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.tabs);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("id", ctx.getElementId("content", ctx.tabIndex));
        i0.ɵɵattribute("aria-labelledby", ctx.getElementId("tab", ctx.tabIndex));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.getActiveTabTemplate());
    } }, dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet], styles: [".nav-tabs[_ngcontent-%COMP%]{margin-bottom:1rem}\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsComponent, [{
        type: Component,
        args: [{ selector: 'mhe-tabs', template: "<div class=\"tablist-label\">\n  <ul\n    role=\"tablist\"\n    class=\"nav\"\n    [class.nav-tabs]=\"!showSteps\"\n    [class.nav-steps]=\"showSteps\"\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n    [attr.aria-labelledby]=\"ariaLabelledBy ? ariaLabelledBy : null\"\n    [attr.aria-owns]=\"getAllTabIds()\"\n  >\n    <li\n      *ngFor=\"let tab of tabs; let i = index\"\n      role=\"presentation\"\n      class=\"nav-item\"\n      [class.active]=\"showSteps && i === tabIndex\"\n      [class.disabled]=\"showSteps && tab.disabled\"\n    >\n      <a\n        #tabElements\n        role=\"tab\"\n        class=\"nav-link\"\n        [id]=\"getElementId('tab', i)\"\n        [class.active]=\"i === tabIndex\"\n        [class.disabled]=\"tab.disabled\"\n        [attr.href]=\"tab.disabled ? null : '#'\"\n        [attr.tabIndex]=\"i === tabIndex ? 0 : -1\"\n        [attr.index]=\"i\"\n        [attr.aria-selected]=\"i === tabIndex\"\n        [attr.aria-controls]=\"getElementId('content', tabIndex)\"\n        [attr.aria-disabled]=\"tab.disabled || null\"\n        (click)=\"tabClicked(i, $event)\"\n      >\n        <span *ngIf=\"showSteps\" class=\"step-number\">{{ i + 1 }}</span>\n        <span [class.step-label]=\"showSteps\" [attr.aria-label]=\"tab.ariaLabel\">{{ tab.name }}</span>\n      </a>\n    </li>\n  </ul>\n\n  <div\n    role=\"tabpanel\"\n    [id]=\"getElementId('content', tabIndex)\"\n    [attr.aria-labelledby]=\"getElementId('tab', tabIndex)\"\n  >\n    <ng-container *ngTemplateOutlet=\"getActiveTabTemplate()\"></ng-container>\n  </div>\n</div>\n", styles: [".nav-tabs{margin-bottom:1rem}/*# sourceMappingURL=tabs.component.css.map */\n"] }]
    }], null, { tabIndex: [{
            type: Input
        }], showSteps: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], ariaLabelledBy: [{
            type: Input
        }], tabClick: [{
            type: Output
        }], tabElements: [{
            type: ViewChildren,
            args: ['tabElements']
        }], tabs: [{
            type: ContentChildren,
            args: [TabComponent]
        }] }); })();
